import { render, staticRenderFns } from "./ServicesTaxResult.vue?vue&type=template&id=3163403d&scoped=true&"
import script from "./ServicesTaxResult.vue?vue&type=script&lang=js&"
export * from "./ServicesTaxResult.vue?vue&type=script&lang=js&"
import style0 from "./ServicesTaxResult.vue?vue&type=style&index=0&id=3163403d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3163403d",
  null
  
)

export default component.exports